import { render, staticRenderFns } from "./faqCard.vue?vue&type=template&id=0733e4d3"
import script from "./faqCard.vue?vue&type=script&lang=js"
export * from "./faqCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports